/**
 * FormField Component
 *
 * Labeled input field with optional tooltip.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a text/number input field.
 *
 * @param {string} key - State key
 * @param {string} label - Field label
 * @param {string} help - Tooltip help text
 * @param {string} type - Input type (text, number, etc.)
 * @param {Object} state - State object containing value
 * @param {Function} onUpdate - Callback when value changes
 * @param {Object} props - Additional properties (styling, padding, attrs, etc.)
 */
export function FormField(key, label, help, type, state, onUpdate, props = {}) {
    const { styling, padding, showBorders = true, ...inputProps } = props;

    const classes = ['presszone-multilingual-input--settings'];
    if (styling) classes.push(`presszone-multilingual-input--styling-${styling}`);
    if (padding) classes.push(`presszone-multilingual-input--padding-${padding}`);
    if (showBorders === false) classes.push('presszone-multilingual-input--no-borders');

    return el('div', { class: 'presszone-multilingual-form-group' },
        el('label', { class: 'presszone-multilingual-label--settings', for: key },
            label,
            help ? el('span', { class: 'presszone-multilingual-tooltip', title: help }, 'i') : null
        ),
        el('input', {
            type,
            id: key,
            class: classes.join(' '),
            value: state[key] !== undefined && state[key] !== null ? state[key] : '',
            onchange: (e) => {
                const value = type === 'number' ? parseInt(e.target.value, 10) : e.target.value;
                state[key] = value;
                if (onUpdate) onUpdate(key, value);
            },
            ...inputProps
        })
    );
}

export default FormField;
